module.exports = __webpack_public_path__ + "img/appIcon-ui--actionRestore.c77f560b.svg";